/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 8" fill="none">
    <path
      d="M6.19961 7.2H3.79961C2.91428 7.2 2.15961 6.88761 1.53561 6.26283C0.911609 5.63817 0.599609 4.88261 0.599609 3.99617C0.599609 3.10983 0.911609 2.35555 1.53561 1.73333C2.15961 1.11111 2.91428 0.799999 3.79961 0.799999H6.19961V2H3.79961C3.24405 2 2.77183 2.19444 2.38294 2.58333C1.99405 2.97222 1.79961 3.44444 1.79961 4C1.79961 4.55555 1.99405 5.02778 2.38294 5.41667C2.77183 5.80555 3.24405 6 3.79961 6H6.19961V7.2ZM4.59961 4.6V3.4H9.39961V4.6H4.59961ZM7.79961 7.2V6H10.1996C10.7552 6 11.2274 5.80555 11.6163 5.41667C12.0052 5.02778 12.1996 4.55555 12.1996 4C12.1996 3.44444 12.0052 2.97222 11.6163 2.58333C11.2274 2.19444 10.7552 2 10.1996 2H7.79961V0.799999H10.1996C11.0849 0.799999 11.8396 1.11239 12.4636 1.73717C13.0876 2.36183 13.3996 3.11739 13.3996 4.00383C13.3996 4.89017 13.0876 5.64444 12.4636 6.26667C11.8396 6.88889 11.0849 7.2 10.1996 7.2H7.79961Z"
      fill="currentColor"
    />
  </svg>
);

const Link2Icon = (props) => <Icon component={svg} {...props} />;

export default Link2Icon;
